import { ReduxStateHandler } from '../ReduxStateHandler';

export const TypeformModalStateHandler = new ReduxStateHandler({
  actionName: 'data/UPDATE_TYPEFORM_MODAL',
  statePath: 'typeformModalData',
});
